import { Navigate } from "react-router-dom";
import Session from "utils/Session";

function PrivateRoute({ component: RouteComponent }) {
  return (
    Session.isLoggedIn() ? (<RouteComponent />) : <Navigate to="/" />
  );
}

export default PrivateRoute;